export const stringArrayToText = (arrayStrings: string[]) => {
  const lastItem = arrayStrings.pop();
  return arrayStrings.length ? [arrayStrings.join(', '), lastItem].join(' e ') : lastItem;
};
